<template>
  <div class="popup-response refusing-popup popup-all" style="display: block">
    <div class="popup-container">
      <div class="popup-vue has-header">
        <div class="popup-header">
          <img class="popup-logo" src="/img/credit-landing-vue/popup-logo.svg">
          <div class="popup-tel" v-html="__t('Телефон для треба уточнити деталі')"></div>
        </div>
        <div class="popup-content-on-mob">
          <div class="popup-img">
            <img src="/img/cash-credit-landing/question.svg" alt="question">
          </div>
          <div class="popup-title" v-html="__t('Треба уточнити деталі')"></div>

          <div class="popup-description" v-if="true">
            <p v-html="__t('Текст для Треба уточнити деталі')"></p>
          </div>

          <div class="button-wrapper page-bottom ">
            <a id="closePopupFocusId" tabindex="0" class="single-button btn violet-btn" @click="popupClose()" @keydown.enter.prevent="popupClose()">{{__t('Закрити')}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

    export default {
        name: 'popup-success',
        props: [],
        data() {
            return {}
        },
        methods: {
            __t(phrase) {
                return window.__t(phrase);
            },

            popupClose: function () {
                this.$emit('popupRefusingHide')
            }
        }
    }

</script>